var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16PxEmailFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4.28571C2 3.57563 2.57563 3 3.28571 3H12.7143C13.4243 3 14 3.57563 14 4.28571V4.57881L8.32863 8.3604C8.24864 8.41183 8.13253 8.44854 7.99999 8.44854C7.86746 8.44854 7.75135 8.41183 7.67136 8.3604L2 4.57882V4.28571ZM2 5.86659V11.5714C2 12.2815 2.57563 12.8571 3.28571 12.8571H12.7143C13.4243 12.8571 14 12.2815 14 11.5714V5.86658L8.92006 9.25381L8.91512 9.2571C8.64542 9.43265 8.32154 9.51997 7.99999 9.51997C7.67845 9.51997 7.35459 9.43263 7.08489 9.25707L7.07992 9.25383L2 5.86659Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxEmailFilled);
export default __webpack_public_path__ + "static/media/icon_16px_email_filled.94f691f2751f83fefe3514ada4cf75c5.svg";
export { ForwardRef as ReactComponent };